/* istanbul ignore file */
import React from 'react';
import { Stack, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { PROGRESS_STATUSES } from 'domain/sales/projectsDashboard/useProjectsDashboardService';
import { ProgressIndicator } from 'framework/ui/field';
import { getProgressFieldIcon } from './field/progressFieldUtils';

const legendItemSx = {
  mb: 0.5,
  mr: '30px',
  '& .project-dashboard-timeline__indicator': {
    flexGrow: 0,
    mr: 1,
    '&::after': {
      content: 'none',
    },
    '& .project-dashboard-timeline__indicator-icon': {
      width: '18px',
      height: '18px',
    },
  },
};

const WORKING_STATUSES_LEGEND = [
  {
    label: 'Not started yet',
    value: PROGRESS_STATUSES.NOT_STARTED,
  },
  {
    label: 'In progress',
    value: PROGRESS_STATUSES.IN_PROGRESS,
  },
  {
    label: 'In progress with delay',
    value: PROGRESS_STATUSES.IN_PROGRESS_WITH_DELAY,
  },
];

const COMPLETED_STATUSES_LEGEND = [
  {
    label: 'Completed without delay',
    value: PROGRESS_STATUSES.COMPLETED,
  },
  {
    label: 'Completed with delay',
    value: PROGRESS_STATUSES.COMPLETED_WITH_DELAY,
  },
];

const ProjectDashboardLegend = ({
  data: blocks = [WORKING_STATUSES_LEGEND, COMPLETED_STATUSES_LEGEND],
  rowDirection,
}: {
  data?: any[];
  rowDirection?: boolean;
}) => {
  const getItems = (
    data: {
      label: string;
      value: PROGRESS_STATUSES;
    }[],
  ) =>
    data.map(({ label, value }) => (
      <Stack key={label} direction="row" alignItems="center" sx={legendItemSx}>
        <ProgressIndicator status={value} icon={getProgressFieldIcon(value)} />

        <Typography component="span" variant="inherit">
          {label}
        </Typography>
      </Stack>
    ));

  return (
    <Stack direction="row" alignItems="flex-start" flexWrap="wrap" sx={{ mt: '30px' }}>
      {blocks.map(block => (
        <Stack
          key={uuidv4()}
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={
            rowDirection
              ? {
                  display: { xs: 'block', md: 'flex' },
                  flexWrap: 'wrap',
                }
              : { display: 'block' }
          }
        >
          {getItems(block)}
        </Stack>
      ))}
    </Stack>
  );
};

export default ProjectDashboardLegend;
